<template>
    <v-container fluid class="container-full-bg-gray">
        <excel-draggable-show-hide-dialog
            v-model="excel_dialog"
            title="Selector de Columnas Excel"
            :show_columns="excel_headers"
            :hide_columns="excel_hidden_headers"
            show_columns_header="Columnas ordenadas del Excel"
            hide_columns_header="Columnas excluidas del Excel"
            :key="'excel_dialog_k'+excel_dialog"
            :loading="isLoading"
            @update="updateExcelColumns"
            @cancel="excel_dialog=false"
        >
            <template v-slot:top_actions>
                <i>
                    * La configuración de empresa prevalece sobre la configuración de usuario.
                </i>
            </template>
        </excel-draggable-show-hide-dialog>
        <draggable-show-hide-dialog
            v-model="list_docs_dialog"
            title="Selector Columnas: Listado Documentos"
            :show_columns="documentListHeadersUser"
            :hide_columns="documentListHiddenHeadersUser"
            :key="'list_docs_dialog_'+list_docs_dialog"
            @update="updateListDocsColumns"
            @cancel="list_docs_dialog=false"
        >
            <template v-slot:top_actions>
                <slot name="actions"></slot>
            </template>
        </draggable-show-hide-dialog>

        <draggable-show-hide-dialog
            v-model="list_supplierdb_dialog"
            title="Selector Columnas: Listado Proveedores"
            :show_columns="supplierdbListHeadersUser"
            :hide_columns="supplierdbListHiddenHeadersUser"
            :key="'list_supplierdb_dialog_'+list_supplierdb_dialog"
            @update="updateListSupplierColumns"
            @cancel="list_supplierdb_dialog=false"
        >
            <template v-slot:top_actions>
                <slot name="actions"></slot>
            </template>
        </draggable-show-hide-dialog>

        <draggable-show-hide-dialog
            v-model="list_customerdb_dialog"
            title="Selector Columnas: Listado Clientes"
            :show_columns="customerdbListHeadersUser"
            :hide_columns="customerdbListHiddenHeadersUser"
            :key="'list_customerdb_dialog_'+list_customerdb_dialog"
            @update="updateListCustomerColumns"
            @cancel="list_customerdb_dialog=false"
        >
            <template v-slot:top_actions>
                <slot name="actions"></slot>
            </template>
        </draggable-show-hide-dialog>

        <v-dialog v-model="notification_dialog" max-width="500">
            <v-card>
                <v-card-title class="headline">
                    Notificaciones por correo
                </v-card-title>
                <v-card-text>
                    <v-checkbox
                        v-model="notificationsEnabled"
                        label="Activar/Desactivar notificaciones."
                        @change="onToggleFlag"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="grey" @click="notification_dialog = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="saveNotifications(notificationsEnabled)">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-page-card>
            <template #header>
                {{ $t("UserConfiguration.header") }}
            </template>
            <template>
                <app-header-with-subtitle>
                    <template #icon>
                        mdi-cog-outline
                    </template>
                    <template>
                        <span v-if="userData && userData.sender_docs_user_distributor_code">{{$t("UserConfiguration.title2")}}</span> 
                        <span v-else>{{$t("UserConfiguration.title1")}}</span>
                    </template>
                    <template #subtitle>
                        {{ $t("UserConfiguration.body") }}
                    </template>
                </app-header-with-subtitle>
                
                <app-container>
                <app-row>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" v-if="got_feature('feature_upload_excel')">
                        <settings-card
                            @click="excel_dialog = true"
                        >
                            <template #icon>
                                mdi-folder-text-outline
                            </template>
                            Ficheros Excel
                            <template #description>
                                Configuración de columnas para ficheros Excel.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" v-if="got_feature('feature_config_table_columns_docs_user')">
                        <settings-card
                            @click="list_docs_dialog = true"
                        >
                            <template #icon>
                                mdi mdi-format-columns
                            </template>
                            Listado Documentos
                            <template #description>
                                Configuración de columnas para el listado de Documentos.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" v-if="got_feature('feature_config_table_columns_thirds_user')">
                        <settings-card
                            @click="list_supplierdb_dialog = true"
                        >
                            <template #icon>
                                mdi mdi-format-columns
                            </template>
                            Listado Proveedores
                            <template #description>
                                Configuración de columnas para el listado de Proveedores.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" v-if="got_feature('feature_config_table_columns_thirds_user') && !got_feature('feature_hide_out_invoice')">
                        <settings-card
                            @click="list_customerdb_dialog = true"
                        >
                            <template #icon>
                                mdi mdi-format-columns
                            </template>
                            Listado Clientes
                            <template #description>
                                Configuración de columnas para el listado de Clientes.
                            </template>
                        </settings-card>
                    </app-col>

                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center">
                    <settings-card @click="notification_dialog = true" v-if="userData.available_features['feature_send_email_not_done_invoices']">
                        <template #icon>
                            mdi-email-alert-outline
                        </template>
                            Notificaciones por correo
                        <template #description>
                            Recibir un listado de empresas con facturas pendientes de contabilizar.
                        </template>
                    </settings-card>
                    </app-col>

                </app-row>
                </app-container>
            </template>
        </app-page-card>
        <v-snackbar
            v-model="snackbar.isVisible"
            :color="snackbar.color"
            :timeout="snackbar.timeout"
        >
            {{ snackbar.text }}
        </v-snackbar>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";
import AppHeaderWithSubtitle from '@/components/layout/AppHeaderWithSubtitle.vue';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import DraggableShowHideDialog from '../components/DraggableShowHideDialog.vue';
import SettingsCard from '@/components/settings/SettingsCard.vue';
import AppContainer from '@/components/layout/AppContainer.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppRow from '@/components/layout/AppRow.vue';
import ExcelDraggableShowHideDialog from '../components/ExcelDraggableShowHideDialog.vue';
import { UserRepo } from "@/modules/reporting/infrastructure/UserRepo";
import { SaveUserInvoiceNotificationCommand, SaveUserInvoiceNotificationCommandHandler } from "@/modules/reporting/application/SaveUserInvoiceNotificationCommand";

export default {
    components: {
        AppHeaderWithSubtitle,
        AppPageCard,
        DraggableShowHideDialog,
        SettingsCard,
        AppContainer,
        AppCol,
        AppRow,
        ExcelDraggableShowHideDialog,
    },
    computed: {
        ...mapFields('me',vuexPrefix('',[
            'feature_config_table_columns_docs_user', 'feature_config_table_columns_thirds_user', 
            'feature_upload_excel', 'feature_iva_agrario_pesca_tabaco',
        ],'userData.available_features.')),
        ...mapFields('config', {
            excel_headers: 'excel_headers',
            excel_hidden_headers: 'excel_hidden_headers',
        }),
        ...mapFields('documents', ['documentListHeadersUser', 'documentListHiddenHeadersUser', 'supplierdbListHeadersUser', 'supplierdbListHiddenHeadersUser', 
        'customerdbListHeadersUser', 'customerdbListHiddenHeadersUser']),
        ...mapGetters({
            userData: 'me/userData',
            got_feature: 'got_feature',
        }),
    },

    data() {
        return {
            list_docs_dialog: false,
            list_supplierdb_dialog: false,
            list_customerdb_dialog: false,
            notification_dialog: false,
            notificationsEnabled: false,
            snackbar: {
                isVisible: false,
                text: '',
                color: '',
                timeout: 2000,
            },
            snackbarTextOK: 'Cambios realizados con éxito.',
            snackbarTextKO: 'Ha habido un error durante el proceso.',
            excel_dialog: false,
            isLoading: false,
        }
    },
    methods: {
        ...mapActions({
            getHeaderUser: "documents/getHeaderUser",
            setHeaderUser: "documents/setHeaderUser",
            refreshUserData: "me/refreshUserData",
            getHeaderSupplierDBUser: "documents/getHeaderSupplierDBUser",
            setHeaderSupplierDBUser: "documents/setHeaderSupplierDBUser",
            getHeaderCustomerDBUser: "documents/getHeaderCustomerDBUser",
            setHeaderCustomerDBUser: "documents/setHeaderCustomerDBUser",
            getColumnsExcel: "config/getColumnsExcel",
            setColumnsExcel: "config/setColumnsExcel",
        }),
        setSnackbar(color, text) {
            this.snackbar.text = text
            this.snackbar.color = color
            this.snackbar.isVisible = true
        },
        updateListDocsColumns(data) {
            this.documentListHeadersUser = data['show'];
            this.documentListHiddenHeadersUser = data['hide'];
            this.setHeaderUser().then(() => {
                this.list_docs_dialog = false;
                this.setSnackbar('success', this.snackbarTextOK);
            }).catch(err => {
                console.error(err);
                this.list_docs_dialog = false;
                this.setSnackbar('error', this.snackbarTextKO);
            });
        },
        updateListSupplierColumns(data) {
            this.supplierdbListHeadersUser = data['show'];
            this.supplierdbListHiddenHeadersUser = data['hide'];
            this.setHeaderSupplierDBUser().then(() => {
                this.list_supplierdb_dialog = false;
                this.setSnackbar('success', this.snackbarTextOK);
            }).catch(err => {
                console.error(err);
                this.list_supplierdb_dialog = false;
                this.setSnackbar('error', this.snackbarTextKO);
            });
        },
        updateListCustomerColumns(data) {
            this.customerdbListHeadersUser = data['show'];
            this.customerdbListHiddenHeadersUser = data['hide'];
            this.setHeaderCustomerDBUser().then(() => {
                this.list_customerdb_dialog = false;
                this.setSnackbar('success', this.snackbarTextOK);
            }).catch(err => {
                console.error(err);
                this.list_customerdb_dialog = false;
                this.setSnackbar('error', this.snackbarTextKO);
            });
        },
        updateExcelColumns(data) {
            this.excel_headers = data['show'];
            this.excel_hidden_headers = data['hide'];
            this.isLoading = true;

            this.setColumnsExcel().then(() => {
                this.setSnackbar('success', this.snackbarTextOK);
                setTimeout(() => {this.excel_dialog = false}, 500);

            }).catch(() => {
                this.setSnackbar('error', this.snackbarTextKO);
                this.excel_dialog = false;
            }).finally(() => {
                this.isLoading = false
            })
        },
        onToggleFlag(value) {
            this.$store.dispatch("me/setUserData", { ...this.userData, enable_invoice_notifications: value });
        },
        async saveNotifications(value) {
            try {
                const command = new SaveUserInvoiceNotificationCommand(this.userData.id, value);
                const handler = new SaveUserInvoiceNotificationCommandHandler(new UserRepo());
                await handler.handle(command);

                this.$store.dispatch("me/setUserData", { ...this.userData, enable_invoice_notifications: value });
                this.setSnackbar("success", this.snackbarTextOK);
                this.notification_dialog = false;
            } catch (err) {
                console.error(err);
                this.setSnackbar("error", this.snackbarTextKO);
            }
        }
    },
    async mounted() {
        if (this.feature_config_table_columns_docs_user) {
            this.getHeaderUser();
        }
        if (this.feature_config_table_columns_thirds_user) {
            this.getHeaderSupplierDBUser();
            this.getHeaderCustomerDBUser();
        }
        if(this.feature_upload_excel){
            this.getColumnsExcel();
        }
        this.notificationsEnabled = this.userData.enable_invoice_notifications || false
    },
}
</script>
